import api from './api';

export const getStudentSummaryAdmin = async (userId) => {
  if (!userId) throw new Error('userId is required');
  const { data } = await api.get(`/analytics/student/${userId}/summary`);
  return data;
};

const analyticsService = {
  getStudentSummaryAdmin,
};

export default analyticsService;
